import * as tslib_1 from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let GoodsContent = class GoodsContent extends Vue {
    constructor() {
        super(...arguments);
        this.showGoldTimer = false;
        this.timeText = '0天00:00:00';
        this.timer = null;
    }
    get price() {
        if (this.skus.length == 1 &&
            this.curLevel.giftsActivity &&
            this.curLevel.giftsActivity.gift &&
            // this.isGift &&
            !this.skuActivity[this.curLevel.id]) {
            return this.curLevel.giftsActivity.activity_price;
        }
        else if (this.skus.length == 1 &&
            this.curLevel.channel_activity &&
            !this.skuActivity[this.curLevel.id]) {
            return this.curLevel.activityPrice;
        }
        else if ((!Object.keys(this.skuActivity).length ||
            !this.skuActivity[this.curLevel.id]) &&
            !this.discountData.activity_type) {
            return this.spu.sale_price;
        }
        return '';
    }
    get showInventoryOrigin() {
        if ((this.discountData && this.discountData.activity_type) ||
            (this.discountData && this.discountData.id) ||
            (this.discountData && this.discountData.id && this.curLevel) ||
            (this.discountData && this.discountData.id && this.showPresellCom)) {
            return false;
        }
        else {
            return true;
        }
    }
    get isShowOriginprice() {
        if (this.showInventoryOrigin &&
            this.spu.origin_price !== this.price &&
            this.spu.origin_price.indexOf('-') < 0) {
            return true;
        }
        return false;
    }
    get goldDiscount() {
        // 金币限时折扣
        if (this.invitationData.discounted_value) {
            return true;
        }
        return false;
    }
    // 是转介绍
    get showSaleCount() {
        let { invitation } = this.$route.query;
        return !!invitation;
    }
    get expandingText() {
        return this.discountData.id && +this.discountData.expanding_deposit < 0.01
            ? `定金抵作同价货款,不退还`
            : `${this.discountData.deposit}元抵扣${this.discountData.expanding_deposit}元，不退还`;
    }
    get inventoryQty() {
        if (!this.skus || !this.skus.length) {
            return 0;
        }
        return this.skus.reduce((sum, s) => {
            return (sum += s.virtual_inventory_qty);
        }, 0);
    }
    get inventoryVisible() {
        if (!this.skus || !this.skus.length) {
            return false;
        }
        return this.skus.every(s => {
            return s.virtual_inventory_visible;
        });
    }
    invitationDataChanged() {
        this.countDownHandle();
    }
    async created() {
        this.countDownHandle();
    }
    showRule() {
        this.$router.push({
            path: `/presellRule`,
            query: {
                ruleUrl: this.discountData.rule_pic,
            },
        });
    }
    countDownHandle() {
        let end = this.invitationData.discount_end;
        let start = this.invitationData.discount_start;
        if (!end)
            return;
        let endTime = +new Date(end.replace(/-/g, '/'));
        let nowTime = +new Date();
        if (endTime <= nowTime) {
            // 已超过倒计时时间,不展示
            this.showGoldTimer = false;
            return;
        }
        else if (nowTime < +new Date(start)) {
            this.showGoldTimer = false;
            return;
        }
        let leftTime = (endTime - nowTime) / 1000;
        // 超过一天,优惠券倒计时不展示
        this.getTime(leftTime);
        this.showGoldTimer = true;
        this.timer && clearInterval(this.timer);
        this.timer = setInterval(() => {
            leftTime -= 1;
            if (leftTime <= 0) {
                clearTimeout(this.timer);
                this.showGoldTimer = false;
                window.location.reload();
            }
            this.getTime(leftTime);
        }, 1000);
    }
    getTime(leftTime) {
        let day = Math.floor(leftTime / 60 / 60 / 24);
        let dayBk = day < 10 ? '0' + day : day;
        let hour = Math.floor((leftTime / 60 / 60) % 24);
        let hourBk = hour < 10 ? '0' + hour : hour;
        let minute = Math.floor((leftTime / 60) % 60);
        let minuteBk = minute < 10 ? '0' + minute : minute;
        let second = Math.floor(leftTime % 60);
        let secondBk = second < 10 ? '0' + second : second;
        this.timeText = `距结束：<span>${dayBk}</span>天<span>${hourBk}</span>:<span>${minuteBk}</span>:<span>${secondBk}</span>`;
    }
};
tslib_1.__decorate([
    Prop()
], GoodsContent.prototype, "spu", void 0);
tslib_1.__decorate([
    Prop()
], GoodsContent.prototype, "invitationData", void 0);
tslib_1.__decorate([
    Prop()
], GoodsContent.prototype, "discountData", void 0);
tslib_1.__decorate([
    Prop()
], GoodsContent.prototype, "curLevel", void 0);
tslib_1.__decorate([
    Prop()
], GoodsContent.prototype, "skuActivity", void 0);
tslib_1.__decorate([
    Prop()
], GoodsContent.prototype, "skus", void 0);
tslib_1.__decorate([
    Prop()
], GoodsContent.prototype, "isGift", void 0);
tslib_1.__decorate([
    Prop()
], GoodsContent.prototype, "showPresellCom", void 0);
tslib_1.__decorate([
    Prop()
], GoodsContent.prototype, "skuTitle", void 0);
tslib_1.__decorate([
    Prop()
], GoodsContent.prototype, "discountPadding", void 0);
tslib_1.__decorate([
    Watch('invitationData', { immediate: true })
], GoodsContent.prototype, "invitationDataChanged", null);
GoodsContent = tslib_1.__decorate([
    Component
], GoodsContent);
export default GoodsContent;
